import {Component, OnInit} from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';

import {ClientService} from '../../services/client.service';
import {Router} from '@angular/router';
import {loginForm} from '../../../Assets/angular/assets/data/forms/login_form';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

    loginForm: Array<object>;
    token: string;
    tokenExpired: boolean;
    modalId = 'modal-error-interceptor';
    textMessage = '';

    constructor(private clientService: ClientService, private router: Router, private metaService: Meta,
                private titleService: Title) {
        this.loginForm = loginForm;
        this.token = this.clientService.getToken();
        this.token != null ? this.tokenExpired = this.clientService.isTokenExpired(this.token) : '';
    }

    ngOnInit(): void {
        if (this.token && !this.tokenExpired) {
            this.router.navigateByUrl('/contratos');
        }
        this.titleService.setTitle('Área de clientes');
        this.metaService.addTag({description: 'Compramos y empeñamos tu oro. ¡Utiliza nuestro servicio de valoracion online para obtener el valor estimado de tu Oro!'});
        this.modalId = this.clientService.modalInfo['id'];
        this.textMessage = this.clientService.modalInfo['message'];
    }
}
